// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReferralNotes_note__TtBTo {
  border: 1px #e7e0f1 solid;
  border-radius: 8px;
  padding: 16px 24px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ReferralNotes_notesContainer__KdgjD {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ReferralNotes_noteLine__3xtGn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ReferralNotes_noteEntryLabelTitle__0i-CY {
  color: #383838;
  font-size: 14px;
  font-weight: 600;
}
.ReferralNotes_noteEntryLabel__7q7uo {
  color: #383838;
  font-size: 14px;
  font-weight: 400;
}
.ReferralNotes_noteItem__dZ-5e {
  display: flex;
  align-items: center;
  justify-content: start;
}
.ReferralNotes_status__YQuCJ {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #383838;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ReferralNotes.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB","sourcesContent":[".note {\n  border: 1px #e7e0f1 solid;\n  border-radius: 8px;\n  padding: 16px 24px 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.notesContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.noteLine {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.noteEntryLabelTitle {\n  color: #383838;\n  font-size: 14px;\n  font-weight: 600;\n}\n.noteEntryLabel {\n  color: #383838;\n  font-size: 14px;\n  font-weight: 400;\n}\n.noteItem {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n}\n.status {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #383838;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"note": `ReferralNotes_note__TtBTo`,
	"notesContainer": `ReferralNotes_notesContainer__KdgjD`,
	"noteLine": `ReferralNotes_noteLine__3xtGn`,
	"noteEntryLabelTitle": `ReferralNotes_noteEntryLabelTitle__0i-CY`,
	"noteEntryLabel": `ReferralNotes_noteEntryLabel__7q7uo`,
	"noteItem": `ReferralNotes_noteItem__dZ-5e`,
	"status": `ReferralNotes_status__YQuCJ`
};
export default ___CSS_LOADER_EXPORT___;
